import React from 'react'
import './StoryFooter.css'
import StoryDate from './StoryDate'

type Props = {
  info: storyInfo
}
export default function StoryFooter(props: Props) {
  return (
    <footer>
      { props.info.comment && <p>{props.info.comment}</p>}
      { 0 < props?.info?.createdAt?.unix() &&
        <dl>
          <dt>このストーリーを作った日</dt>
          <dd>
            <StoryDate date={props.info.createdAt} />
          </dd>
        </dl>
      }
    </footer>
  )
}
